export default [
  {
    //  序言
    path: "/introduction",
    name: "introduction",
    component: () => import("@/views/introduction/index.vue"),
    meta: {
      title: "序言",
      order: 2,
      episode: "preface",
      prefetchAssets: {
        isLoad: false,
        assets: ["images/introduction/bg-0.jpg"],
      },
    },
  },
];
